import { setPageLoaderAction } from "./commonActionCreator";
import {
  changePasswordLoaderAction,
  requestNewPasswordLoaderAction,
  setLoginLoaderAction,
  setPreLoginLoaderAction,
} from "./loginActionCreator";
import {
  setCreateForumCommentLoader,
  setCreateForumThreadLoader,
  setCreateForumTooicLoader,
  setDeletePollLoader,
  setDistributePollLoader,
  setForumTopicLoader,
  setisPollexistLoader,
  setLockPollLoader,
  setPollLoader,
  setUnlockPollLoader,
} from "./socialActionCreator";
import {
  deleteShotclassLoaderAction,
  setAddBulkUploadCSVLoaderAction,
  setAddTrainingLoaderAction,
  setAddTranscribeTagLoaderAction,
  setDeleteQuizImagesLoaderAction,
  setDeleteTrainingLoaderAction,
  setGetLanguagesLoaderAction,
  setGetOnlineCoursesLoaderAction,
  setGetShotclassTagLoaderAction,
  setGetSlidesharesLoaderAction,
  setGetTrainingTypesLoaderAction,
  setGetTranscriptionDataLoaderAction,
  setGetUserGroupsLoaderAction,
  setGetYoutubeVideosLoaderAction,
  setIsShotclassNameExistLoaderAction,
  setSaveAsADraftLoaderAction,
  setShotclassPublishLoaderAction,
  setUploadQuizImagesLoaderAction,
} from "./manageActionCreator";
import {
  addUserEmailDetailsLoaderAction,
  getPasswordExpiryLoaderAction,
  getUserEmailDetailsLoaderAction,
  setAddUploadCSVLoaderAction,
  setPasswordExpiryLoaderAction,
} from "./adminActionCreator/orgizationActionCreator";
import {
  setCreateRoleLoaderAction,
  setPostLoadersAction,
  setRoleNameCheckLoaderAction,
} from "./adminActionCreator/rolesAndPermissionsActionCreator";
import {
  getAllRolesLoaderAction,
  getCityListLoaderAction,
  getCountryListLoaderAction,
  getProductCategoryListLoaderAction,
  getStateListLoaderAction,
  getUserGroupsLoaderAction,
  getWorkOfficeListLoaderAction,
  isLoginIdExistsLoaderAction,
  postUserProfileLoaderAction,
  putUserProfileLoaderAction,
  toggleUserStatusLoaderAction,
  unlockUserAccountLoaderAction,
} from "./adminActionCreator/userManagementActionCreator";
import {
  deleteCertificateLoaderAction,
  postEditCertificateLoaderAction,
  postNewCertificateLoaderAction,
  uploadCertificateLoaderAction,
} from "./adminActionCreator/certificateManagementActionCreator";
import {
  deleteNotificationLoaderAction,
  triggerNotificationLoaderAction,
} from "./adminActionCreator/engagementCenterActionCreator";
import { setMyProfileLoader } from "./headerActionCreator";


const loaders = {
  common: {
    pageLoader: setPageLoaderAction,
  },
  login: {
    preLoginLoader: setPreLoginLoaderAction,
    loginLoader: setLoginLoaderAction,
    requestNewPasswordLoader: requestNewPasswordLoaderAction,
    changePasswordLoader: changePasswordLoaderAction,
  },
  manage: {
    deleteShotclassLoader: deleteShotclassLoaderAction,
    createTrainingType: {
      addTrainingLoader: setAddTrainingLoaderAction,
      deleteTrainingLoader: setDeleteTrainingLoaderAction,
    },
    contentBulkUpload: {
      addCSVBulkUploadLoader: setAddBulkUploadCSVLoaderAction,
      deleteQuizImagesLoader: setDeleteQuizImagesLoaderAction,
      uploadQuizImagesLoader: setUploadQuizImagesLoaderAction,
    },
    createShotclasses: {
      getTrainingTypesLoader: setGetTrainingTypesLoaderAction,
      getLanguagesLoader: setGetLanguagesLoaderAction,
      isShotclassNameExistsLoader: setIsShotclassNameExistLoaderAction,
      getShotClassTagLoader: setGetShotclassTagLoaderAction,
      saveAsADraftLoader: setSaveAsADraftLoaderAction,
      getUserGroupsLoader: setGetUserGroupsLoaderAction,
      shotclassPublishLoader: setShotclassPublishLoaderAction,
      getYoutubeVideosLoader: setGetYoutubeVideosLoaderAction,
      getOnlineCoursesLoader: setGetOnlineCoursesLoaderAction,
      getSlidesharesLoader: setGetSlidesharesLoaderAction,
    },
    manageTransciption: {
      getTranscriptionDataLoader: setGetTranscriptionDataLoaderAction,
      addTranscribeTagLoader: setAddTranscribeTagLoaderAction,
    },
  },
  admin: {
    organizationSettings: {
      addCSVUploadLoader: setAddUploadCSVLoaderAction,
      getPasswordExpiryLoader: getPasswordExpiryLoaderAction,
      setPasswordExpiryLoader: setPasswordExpiryLoaderAction,
      getUserEmailDetailsLoader: getUserEmailDetailsLoaderAction,
      addUserEmailDetailsLoader: addUserEmailDetailsLoaderAction,
    },
    rolesAndPermissions: {
      postRoleLoader: setPostLoadersAction,
      createRoleLoader: setCreateRoleLoaderAction,
      roleNameCheckLoader: setRoleNameCheckLoaderAction,
    },
    userManagement: {
      unlockUserAccountLoader: unlockUserAccountLoaderAction,
      toggleUserStatusLoader: toggleUserStatusLoaderAction,
      isLoginIdExistsLoader: isLoginIdExistsLoaderAction,
      getCountryListLoader: getCountryListLoaderAction,
      getStateListLoader: getStateListLoaderAction,
      getCityListLoader: getCityListLoaderAction,
      getWorkOfficeListLoader: getWorkOfficeListLoaderAction,
      getProductCategoryListLoader: getProductCategoryListLoaderAction,
      getUserGroupsLoader: getUserGroupsLoaderAction,
      getAllRolesLoader: getAllRolesLoaderAction,
      postUserProfileLoader: postUserProfileLoaderAction,
      putUserProfileLoader: putUserProfileLoaderAction,
    },
    certificateManagement: {
      deleteCertificateLoader: deleteCertificateLoaderAction,
      uploadCertificateLoader: uploadCertificateLoaderAction,
      postNewCertificateLoader: postNewCertificateLoaderAction,
      postEditCertificateLoader: postEditCertificateLoaderAction,
    },
    engagementCenter: {
      triggerNotificationLoader: triggerNotificationLoaderAction,
      deleteNotificationLoader: deleteNotificationLoaderAction,
    },
  },
  events: {
    
  },
  header: {
    profileLoader: setMyProfileLoader,
  },
  reports: {},
  social: {
    pollLoader: setPollLoader,
    unlockPollLoader: setUnlockPollLoader,
    lockPollLoader: setLockPollLoader,
    deletePollLader: setDeletePollLoader,
    distributePollLoader: setDistributePollLoader,
    pollNameExistLoadingLoader: setisPollexistLoader,
    forumArea: {
      createForumTopicLoader: setCreateForumTooicLoader,
      createForumThreadLoader: setCreateForumThreadLoader,
      createForumCommentLoader: setCreateForumCommentLoader,
      forumTopicLoader: setForumTopicLoader,
    },
  },
};

export default loaders;
